jQuery( document ).ready( function( $ ) {

    /**
     * Set toggle for site search
     */ 
    $(".nav-search").click(function() {
      $(".site-container").toggleClass("search-active");      
      $(".site-search").toggleClass("active");
      $(".site-header").toggleClass("search-active");
    });


    /**
     * Add class to navbar-toggler when clicked
     */
    $(".navbar-toggler").click(function() {
        $(this).toggleClass('open');
    });


    /**
     * Set cookie for site notification dismissal
     */    
    if ($.cookie('site_note_close') != 'true') {
      $('#site-notification').removeClass('d-none');

      $('.site-note-close').click(function() {
        $.cookie('site_note_close', 'true', { expires: 10, path: '/' });
        //alert($.cookie('site_note_close')); 
      });
    } else if ($.cookie('site_note_close') === 'true') {        
      //alert($.cookie('site_note_close')); 
    };     
  
  
    /**
     * Case Study Slick Slider
     */
    $('.case-study-slider.slick-slideshow').slick({
      dots: false,
      nextArrow: '<button class="slide-next"></button>',
      prevArrow: '<button class="slide-prev"></button>',
    });


    /**
     * Slick Gallery (Capability Child Pages)
     */
    var $slickElement = $('.slider-for');
    var $sliderNav = $('.slider-nav');

    $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        //$status.text('<span>0' + i + '</span> — ' + '0' + slick.slideCount);
        $( '.paging-info' ).html(function() {
          return '<p><span>' + i + '</span> — ' + slick.slideCount + '</p>';
        });    
    });

    $('.slider-for.slick-slideshow').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.slider-nav'      
    });
    $('.slider-nav.slick-slideshow').slick({
      slidesToShow: 10,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      centerMode: false,
      focusOnSelect: true
    });


    /**
     * Create a "clickable" class which makes entire container clickable
     */
    $(".clickable").click(function() {
        window.location = $(this).find("a").attr("href"); 
        return false;
    });


    /**
     * Hover trigger for Dropdown
     */
    function hover_nav_fix() {
        var nav_selector = $(".site-header .navbar");
        var responsive_breakpoint = "";

        if ( nav_selector.hasClass("navbar-expand-lg") ) {
          responsive_breakpoint = 992;
        } else if ( nav_selector.hasClass("navbar-expand-md") ) {
          responsive_breakpoint = 768;
        } else if ( nav_selector.hasClass("navbar-expand-sm") ) {
          responsive_breakpoint = 576;
        }

        if ($(window).width() < nav_selector) {
          $(".dropdown-toggle").attr('data-toggle', 'dropdown');
        } else {
          $(".dropdown-toggle").removeAttr('data-toggle dropdown');
        }        
    }

    // update data-toggle attribute based on window size/resize
    $(window).resize(function() {
        hover_nav_fix();
    });


    /**
     * Smooth Scroll Hashed Links
     * This will scroll to link on same page
     * Or will smoothly scroll to a hashed section on another page after click
     */

    // first check if the window location contains a hash, then set it to top straight away
    if (window.location.hash) scroll(0,0);
    // void some browsers issue
    setTimeout( function() { scroll(0,0); }, 1);

    $(function() {
      // your current click function
      // select all links with hashes, remove if don't link to anything (:not)
      // this is for same page hashed links
      $('a[href*=\\#]:not([href=\\#])').on("click", function() {
          if (!$(this).parents('ul').hasClass('nav-tabs')) {
              var target = $(this.hash);
              // if target.length is 0, set target equal to the name attribuite with hash as value
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // smooth scroll to the target id
              if (target.length) {
                  $('html,body').animate({
                      scrollTop: target.offset().top
                  }, 1000);
                  return false;
              }
          }
      });

      // check if the window location (URL) has a hash in it
      // smoothly scroll to that location
      if(window.location.hash) {
          var target = $(window.location.hash);
          // if target.length is 0, set target equal to the name attribuite with hash as value
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          // smooth scroll to the target id
          $('html, body').animate({
            scrollTop: $(target).offset().top + 'px'
          }, 1000);
          return false;
      }

    });

    $('.resource-image-container').mouseover(function(){
        $(this).parent('.resource-row').find('.btn-target .button').toggleClass('hover');
    }).mouseout(function(){
        $(this).parent('.resource-row').find('.btn-target .button').toggleClass('hover');
    });


    /**
     * Enable Popovers on About page
     */
    $(function () {
      $('[data-toggle="popover"]').popover();
    })     


    /**
     * Initialize Emergence
     * This will allow us to use the Emergence data-attribute to show/hide items
     * https://github.com/xtianmiller/emergence.js
     */
    emergence.init({
      reset: false,
    });



    // GSAP =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    //=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

    // If we want to animate the bars they have to be seperate elements. 
    // I don't think we'll be able to do that the way its currently set up
    // 
    // We also need to use less generic classes so we can differentiate 
    // between the homepage hero and some other hero

    //if ($("#home-content").length) { 

      //function triggerHomepage() {
        //TweenLite.from('.hero-content', 0.75, {ease: Power2.easeInOut,opacity:0,delay:0.25,onComplete:triggerHomepage}); 

        //TweenLite.to('.hero-top', 1, {width: "100%"}, {width: "0%", ease: Power2.easeInOut,opacity:1,scaleX:1,delay:1});
        //TweenLite.to('.hero-left', 1, {height: "100%"}, {height: "0%", ease: Power2.easeInOut,opacity:1,scaleY:1,delay:1});
        //TweenLite.to('.hero-right', 1, {height: "100%"}, {height: "0%", ease: Power2.easeInOut,opacity:1,scaleY:1,delay:2});
        //TweenLite.to('.hero-left-bottom', 1, {width: "40%"}, {width: "0%", ease: Power2.easeInOut,opacity:1,scaleX:.4,delay:2});
        //TweenLite.to('.hero-right-bottom', 1, {width: "40%"}, {width: "0%", ease: Power2.easeInOut,opacity:1,scaleX:.4,delay:4});
        
        //TweenLite.to('.hero-content', 1, {ease: Power2.easeInOut,opacity:1,delay:.25}); 
        //TweenLite.to('.hero-content h1', .5, {ease: Power2.easeInOut,opacity:1,y:-10,delay:0.35});
        //TweenLite.to('.hero-content h2',.5, {ease: Power2.easeInOut,opacity:1,y:-10,delay:0.45});
        //TweenLite.to('.hero-content .scroll-link', 2, {ease: Power2.easeInOut,opacity:1,scaleX:1, scaleY:1,delay:0.5});
      //}

      //triggerHomepage();      

    //}

   // are we on the contact page
   var contact = $("body").hasClass("page-id-11");
   if(contact===true){
     $('.scroll-link').click();
    var urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('interests')){
          // alert('Interests found');
          //$('.scroll-link').click();
           $([document.documentElement, document.body]).animate({
        scrollTop: $("#main-contact").offset().top
    }, 1000);

      } 

   }


});
